<template>
  <v-card id="edit-payment-day">
    <v-card-title class="i-card-title-div">
      <v-row class="align-center">
        <v-col cols="12" sm="9">
          <span class="g-bold g-heading-l">{{
            newPaymentDayRule
              ? 'Customise Payment Days'
              : 'Customise Payment Days'
          }}</span>
        </v-col>
        <v-col cols="12" sm="3">
          <i-instructions
            instructionKey="data-maintenance/payment-days/add-dialog"
          ></i-instructions>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="py-8 i-card-content-div">
      <v-alert
        border="left"
        class="i-alert"
        dense
        text
        outlined
        elevation="1"
        type="info"
        v-if="!newPaymentDayRule"
      >
        <template v-if="activePaymentDay"
          >For active Payment Days only End Date can be modified</template
        >
        <template v-else
          >For upcoming Payment Days Target Type cannot be modified</template
        >
      </v-alert>

      <p class="g-bold g-heading-s g-text-color-black mt-2">Target Type</p>
      <div class="mb-6">
        <v-radio-group
          class="i-radio-group"
          :disabled="!newPaymentDayRule"
          @change="resetTargetTypeForm"
          v-model="targetType"
        >
          <v-row>
            <!--            <v-col cols="12" md="4" class="pb-0">-->
            <!--              <div-->
            <!--                class="item-div-mini mb-0"-->
            <!--                :class="{ 'item-div-active': targetType === BANNER_GROUP }"-->
            <!--              >-->
            <!--                <v-radio label="Banner Group(s)" :value="BANNER_GROUP"></v-radio>-->
            <!--              </div>-->
            <!--            </v-col>-->
            <v-col cols="12" md="4" class="pb-0">
              <div
                class="item-div-mini mb-0"
                :class="{
                  'item-div-active': targetType === MULTI_STORE_OPERATOR
                }"
              >
                <v-radio
                  label="Multi-Store Operator(s)"
                  :value="MULTI_STORE_OPERATOR"
                ></v-radio>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="pb-0">
              <div
                class="item-div-mini mb-0"
                :class="{ 'item-div-active': targetType === RETAILER_STORE }"
              >
                <v-radio
                  :label="isILR ? 'Customer(s)' : 'Retailer(s)'"
                  :value="RETAILER_STORE"
                ></v-radio>
              </div>
            </v-col>
          </v-row>
        </v-radio-group>
      </div>

      <template v-if="targetType === BANNER_GROUP">
        <p class="g-bold g-heading-s g-text-color-black">Banner Group(s)</p>
        <v-autocomplete
          attach
          background-color="#0000000f"
          class="mt-4 mb-6"
          clearable
          deletable-chips
          dense
          :disabled="activePaymentDay"
          :items="targetBannerGroups"
          label="Select Banner Group(s)"
          multiple
          outlined
          :rules="[(v) => !!v.length || 'Banner Group(s) required']"
          v-model:search-input="searchInput"
          small-chips
          v-model="targetBannerGroupIds"
          @change="searchInput = ''"
        ></v-autocomplete>
      </template>

      <template v-if="targetType === MULTI_STORE_OPERATOR">
        <p class="g-bold g-heading-s g-text-color-black">
          Multi-Store Operator(s)
        </p>
        <v-autocomplete
          attach
          background-color="#0000000f"
          class="mt-3 mb-6"
          clearable
          deletable-chips
          dense
          :disabled="activePaymentDay"
          :items="targetMultiStoreOperators"
          label="Select Multi-Store Operator(s)"
          multiple
          outlined
          :rules="[(v) => !!v.length || 'Multi-Store Operator(s) required']"
          v-model:search-input="searchInput"
          small-chips
          v-model="targetMultiStoreOperatorIds"
          @change="searchInput = ''"
        ></v-autocomplete>
      </template>

      <template v-if="targetType === RETAILER_STORE">
        <p class="g-bold g-heading-s g-text-color-black">
          {{ isILR ? 'Customer(s)' : 'Retailer(s)' }}
        </p>
        <v-autocomplete
          attach
          background-color="#0000000f"
          class="mt-3 mb-6"
          clearable
          deletable-chips
          dense
          :disabled="activePaymentDay"
          :items="targetStores"
          :label="`Select ${isILR ? 'Customer(s)' : 'Retailer(s)'}`"
          multiple
          outlined
          :rules="[
            (v) =>
              !!v.length || `${isILR ? 'Customer(s)' : 'Retailer(s)'} required`
          ]"
          v-model:search-input="searchInput"
          small-chips
          v-model="targetStoreIds"
          @change="searchInput = ''"
        ></v-autocomplete>
      </template>

      <template v-if="targetType !== RETAILER_STORE">
        <p class="g-bold g-heading-s g-text-color-black mt-2">
          Payment Days Geography
        </p>
        <div class="mb-6">
          <v-radio-group
            class="i-radio-group"
            :disabled="activePaymentDay"
            v-model="targetGeography"
            @change="resetTargetGeographyForm"
          >
            <v-row>
              <v-col cols="12" md="4" class="pb-0">
                <div
                  class="item-div-mini mb-0"
                  :class="{ 'item-div-active': targetGeography === NATIONAL }"
                >
                  <v-radio label="National" :value="NATIONAL"></v-radio>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pb-0">
                <div
                  class="item-div-mini mb-0"
                  :class="{ 'item-div-active': targetGeography === STATE }"
                >
                  <v-radio label="State(s)" :value="STATE"></v-radio>
                </div>
              </v-col>
            </v-row>
          </v-radio-group>
        </div>

        <template v-if="targetGeography === STATE">
          <p class="g-bold g-heading-s g-text-color-black mt-2">State(s)</p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-3 mb-6"
            clearable
            deletable-chips
            dense
            :disabled="activePaymentDay"
            hide-details
            :items="states"
            label="Select State(s)"
            multiple
            outlined
            :rules="[
              (v) => !!v.length || 'State(s) required for State Payment Days'
            ]"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetStoreDeliveryAddressStates"
            @change="searchInput = ''"
          ></v-autocomplete>
        </template>
      </template>

      <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4">
        Payment Days Date Range
        <v-icon
          class="i-tooltip-color pb-1"
          small
          v-tooltip="
            'Starts at 12:00am & Ends at 11:59pm on the submitted dates'
          "
        >
          mdi-help-circle-outline
        </v-icon>
      </p>
      <v-row align="center">
        <v-col cols="12" sm="6">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="15"
            :nudge-top="30"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                class="mt-0"
                :disabled="activePaymentDay"
                v-model="startDateDisplay"
                label="Start Date *"
                background-color="#0000000f"
                dense
                outlined
                append-icon="mdi-calendar"
                readonly
                v-on="on"
                :rules="[
                  (v) => !!v || 'Start Date required',
                  validStartSate(startDate, endDate)
                ]"
              ></v-text-field>
            </template>
            <v-date-picker
              :min="minAllowedStartDate"
              v-model="startDate"
              @change="startDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="15"
            :nudge-top="30"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-model="endDateDisplay"
                append-icon="mdi-calendar"
                background-color="#0000000f"
                dense
                label="End Date *"
                outlined
                readonly
                :rules="[
                  (v) => !!v || 'End Date required',
                  validEndDate(startDate, endDate)
                ]"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :min="minAllowedEndDate"
              v-model="endDate"
              @change="endDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="mt-n4" align="center">
        <v-col cols="12" sm="6">
          <p class="g-bold g-heading-s g-text-color-black">Payment Days</p>
          <v-select
            background-color="#0000000f"
            class="mt-2"
            dense
            :disabled="activePaymentDay"
            :items="allowedPaymentDaysWithoutDefaultForSelect"
            label="Payment Days *"
            outlined
            :rules="[(v) => v >= 0 || 'Payment Days required']"
            v-model="paymentDays"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
      <v-btn rounded text class="i-btn-text-black" @click="$emit('cancel')"
        >Cancel</v-btn
      >
      <v-btn
        rounded
        class="i-btn-block-secondary mr-4"
        :disabled="!validPaymentDayRule"
        :loading="saving"
        @click="savePaymentDayRule"
        >{{ newPaymentDayRule ? 'Create' : 'Update' }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import { mapActions, mapGetters, mapState } from 'vuex'
import {
  createPaymentDayRule,
  updatePaymentDayRule
} from '@/services/paymentDays'
import iInstructions from '@/components/Instructions'
import FieldValidators from '@/utils/FieldValidators'

const PAYMENT_DAY_RULE_FIELDS = {
  id: '',
  endDate: null,
  startDate: null,
  targetType: null,
  targetGeography: null,
  targetBannerGroupIds: [],
  targetMultiStoreOperatorIds: [],
  targetStoreIds: [],
  targetStoreDeliveryAddressStates: [],
  paymentDays: 0
}

const TARGET_GEOGRAPHY = {
  NATIONAL: 'NATIONAL',
  STATE: 'STATE',
  STORE: 'STORE'
}

const TARGET_TYPE = {
  BANNER_GROUP: 'BANNER_GROUP',
  MULTI_STORE_OPERATOR: 'MULTI_STORE_OPERATOR',
  RETAILER_STORE: 'RETAILER_STORE'
}

export default {
  components: {
    iInstructions
  },

  data: () => ({
    endDateMenu: false,
    startDateMenu: false,
    searchInput: '',
    originalRule: {},
    saving: false,
    states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
    targetBannerGroups: [],
    targetMultiStoreOperators: [],
    targetStores: [],
    ...FieldValidators,
    ...PAYMENT_DAY_RULE_FIELDS,
    ...TARGET_GEOGRAPHY,
    ...TARGET_TYPE
  }),

  props: {
    rule: Object,
    allowedPaymentDays: Array
  },

  computed: {
    ...mapGetters('profile', ['defaultPaymentDays']),
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapState('multiStoreOperators', ['multiStoreOperators']),
    ...mapState('bannerGroups', ['bannerGroups']),
    ...mapState('stores', ['retailerStores']),
    ...mapGetters('tenant', ['isILR']),

    allowedPaymentDaysWithoutDefault() {
      return this.allowedPaymentDays.filter(
        (day) => day !== this.defaultPaymentDays
      )
    },

    allowedPaymentDaysWithoutDefaultForSelect() {
      return this.allowedPaymentDaysWithoutDefault.map((item) => {
        return {
          text: item,
          value: item
        }
      })
    },

    activePaymentDay() {
      return this.rule.status === 'ACTIVE'
    },

    beforeEndDate() {
      return this.startDate <= this.endDate
    },

    newPaymentDayRule() {
      return _.isEmpty(this.rule)
    },

    changesMade() {
      return !_.isEqual(this.originalRule, this.createBluePrint())
    },

    endDateDisplay() {
      return this.$options.filters.formatDatePicker(this.endDate)
    },

    startDateDisplay() {
      return this.$options.filters.formatDatePicker(this.startDate)
    },

    minAllowedEndDate() {
      return this.activePaymentDay
        ? moment().format('YYYY-MM-DD')
        : this.startDate
          ? this.startDate
          : this.minAllowedStartDate
    },

    minAllowedStartDate() {
      return moment().add(1, 'days').format('YYYY-MM-DD')
    },

    validGeography() {
      return (
        this.targetType === this.RETAILER_STORE ||
        this.targetGeography === this.NATIONAL ||
        (this.targetGeography === this.STATE &&
          !!this.targetStoreDeliveryAddressStates.length)
      )
    },

    validTargetType() {
      return (
        (this.targetType === this.BANNER_GROUP &&
          !!this.targetBannerGroupIds.length) ||
        (this.targetType === this.MULTI_STORE_OPERATOR &&
          !!this.targetMultiStoreOperatorIds.length) ||
        (this.targetType === this.RETAILER_STORE &&
          !!this.targetStoreIds.length)
      )
    },

    validPaymentDayRuleDates() {
      return this.startDate && this.endDate >= this.startDate
    },

    validPaymentDays() {
      return this.paymentDays >= 0
    },

    validPaymentDayRule() {
      return (
        this.validTargetType &&
        this.validGeography &&
        this.validPaymentDayRuleDates &&
        this.validPaymentDays &&
        this.changesMade
      )
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    // ***
    // Functions related to help determining if rule has been modified
    // ***
    createBluePrint() {
      return {
        id: this.id,
        endDate: this.endDate,
        startDate: this.startDate,
        targetGeography: this.targetGeography,
        paymentDays: this.paymentDays,
        targetBannerGroupIds: this.targetBannerGroupIds,
        targetMultiStoreOperatorIds: this.targetMultiStoreOperatorIds,
        targetStoreIds: this.targetStoreIds,
        targetStoreDeliveryAddressStates: this.targetStoreDeliveryAddressStates,
        targetType: this.targetType
      }
    },

    // ***
    // Functions related to rule actions
    // ***

    createPaymentDayRule(payload) {
      createPaymentDayRule(this.selectedSupplierId, payload)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Payment Days have been created!'
          })
          this.$emit('save')
        })
        .catch((err) => {
          this.saving = false
          let msg = ''
          switch (err.response?.data?.code || 'UNKNOWN_ERROR') {
            case 'SUPPLIER_PAYMENT_DAY_END_DATE_MUST_BE_AFTER_START_DATE':
              msg = 'Payment Days End Date must be after Start Date...'
              break

            case 'SUPPLIER_PAYMENT_DAY_END_DATE_MUST_BE_AFTER_TODAY':
              msg = 'Payment Days End Date must be after today...'
              break

            case 'SUPPLIER_PAYMENT_DAY_START_DATE_MUST_BE_AFTER_TODAY':
              msg = 'Payment Days Start Date must be after today...'
              break

            default:
              msg = 'Payment Days could not be created, please try again...'
          }
          this.addNotification({ color: 'error', text: msg })
        })
    },

    copyPaymentDayRule() {
      this.id = this.rule.id
      this.endDate = this.rule.endDate
      this.startDate = this.rule.startDate
      this.targetGeography = this.rule.targetGeography
      this.paymentDays = this.rule.paymentDays
      this.targetBannerGroupIds =
        this.rule.targetBannerGroups?.map(
          (bannerGroup) => bannerGroup.bannerGroupId
        ) || []
      this.targetMultiStoreOperatorIds =
        this.rule.targetMultiStoreOperators?.map(
          (mso) => mso.multiStoreOperatorId
        ) || []
      this.targetStoreIds =
        this.rule.targetStores?.map((store) => store.storeId) || []
      this.targetStoreDeliveryAddressStates =
        this.rule.targetStoreDeliveryAddressStates?.map(
          (state) => state.state
        ) || []
      this.targetType = this.determineTargetType()
    },

    updatePaymentDayRule(payload) {
      updatePaymentDayRule(this.selectedSupplierId, this.id, payload)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Payment Days have been updated!'
          })
          this.$emit('save')
        })
        .catch((err) => {
          this.saving = false
          let msg = ''
          switch (err.response?.data?.code || 'UNKNOWN_ERROR') {
            case 'SUPPLIER_PAYMENT_DAY_END_DATE_MUST_BE_AFTER_START_DATE':
              msg = 'Payment Days End Date must be after Start Date...'
              break

            case 'SUPPLIER_PAYMENT_DAY_END_DATE_MUST_BE_AFTER_TODAY':
              msg = 'Payment Days End Date must be after today...'
              break

            case 'SUPPLIER_PAYMENT_DAY_EDIT_NOT_ALLOWED_FOR_PAST':
              msg =
                'Payment Days Edit is not available for PAST Payment Days...'
              break

            default:
              msg = 'Payment Days could not be updated, please try again...'
          }
          this.addNotification({ color: 'error', text: msg })
        })
    },

    savePaymentDayRule() {
      this.saving = true

      const payload = {
        endDate: this.endDate,
        startDate: this.startDate,
        paymentDays: this.paymentDays,
        targetBannerGroupIds: this.targetBannerGroupIds,
        targetMultiStoreOperatorIds: this.targetMultiStoreOperatorIds,
        targetStoreIds: this.targetStoreIds,
        targetStoreDeliveryAddressStates: this.targetStoreDeliveryAddressStates
      }

      this.newPaymentDayRule
        ? this.createPaymentDayRule(payload)
        : this.updatePaymentDayRule(payload)
    },

    // ***
    // Functions related data mapping
    // ***

    mapBannerGroupsList() {
      if (this.bannerGroups?.length > 0) {
        // Map property names so that it works with V-select component
        this.targetBannerGroups = this.bannerGroups
          .map((bannerGroup) => ({
            text: bannerGroup.displayName,
            value: bannerGroup.id
          }))
          .sort((a, b) => (a.text > b.text ? 1 : -1))
      } else {
        this.addNotification({
          color: 'secondary',
          text: 'Available Banner Groups loading, please wait...'
        })
      }
    },

    mapMultiStoreOperatorsList() {
      if (this.multiStoreOperators?.length > 0) {
        // Map property names so that it works with V-select component
        this.targetMultiStoreOperators = this.multiStoreOperators
          .map((mso) => ({
            text: mso.displayName,
            value: mso.id
          }))
          .sort((a, b) => (a.text > b.text ? 1 : -1))
      } else {
        this.addNotification({
          color: 'secondary',
          text: 'Available Multi-Store Operators loading, please wait...'
        })
      }
    },

    mapStoresList() {
      if (this.retailerStores?.length > 0) {
        // Map property names so that it works with V-select component
        this.targetStores = this.retailerStores
          .map((store) => ({
            text: store.displayName,
            value: store.id
          }))
          .sort((a, b) => (a.text > b.text ? 1 : -1))
      } else {
        this.addNotification({
          color: 'secondary',
          text: `Available ${this.isILR ? 'Customer' : 'Retailer'} loading, please wait...`
        })
      }
    },

    // ***
    // Helper Functions
    // ***

    determineTargetType() {
      if (this.targetBannerGroupIds.length) return this.BANNER_GROUP
      else if (this.targetMultiStoreOperatorIds.length)
        return this.MULTI_STORE_OPERATOR
      else if (this.targetStoreIds.length) return this.RETAILER_STORE
      else return null
    },

    resetTargetTypeForm() {
      this.targetBannerGroupIds = []
      this.targetMultiStoreOperatorIds = []
      this.targetStoreIds = []

      // Need to reset target geography info as this concept does not apply to Retailer Stores
      if (this.targetType === this.RETAILER_STORE) {
        this.targetGeography = null
        this.resetTargetGeographyForm()
      }
    },

    resetTargetGeographyForm() {
      this.targetStoreDeliveryAddressStates = []
    }
  },

  mounted() {
    this.mapBannerGroupsList()
    this.mapMultiStoreOperatorsList()
    this.mapStoresList()
    if (!this.newPaymentDayRule) this.copyPaymentDayRule()
    // Create blueprint of rule so that we can know if changes were made
    this.originalRule = _.cloneDeep(this.createBluePrint())
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#edit-payment-day {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  box-shadow: none;
  background: $bg-secondary-color;
  .v-card__text {
    flex-grow: 1;
    overflow: auto;
  }
}
</style>
